
// 红包墙曝光埋点值
export const COUPON_WALL_BID_MV = {
  CARD: 'b_waimai_uytcitgh_mv', // 券墙卡片
  COUPON: 'b_waimai_o65d1m5c_mv', // 券墙券
  USE_BUTTON: 'b_waimai_yixdn6v8_mv', // 券墙使用按钮
  TAB: 'b_waimai_q2fr57g2_mv', // 券墙Tab
}

// 红包墙点击埋点值
export const COUPON_WALL_BID_MC = {
  CARD: 'b_waimai_uytcitgh_mc', // 券墙点击
  COUPON: 'b_waimai_o65d1m5c_mc', // 券墙券点击
  USE_BUTTON: 'b_waimai_yixdn6v8_mc', // 券墙使用按钮
  TAB: 'b_waimai_q2fr57g2_mc', // 券墙Tab
  TAB_SCROLL: 'b_waimai_jqbge11k_mc', // 券墙Tab滚动
  RECEIVE_BUTTON: 'b_waimai_gci8oda9_mc', // 券墙领取按钮
  AFTER_RECEIVE: 'b_waimai_di5x910x_mc', // 券领取完成
}

// 下挂券相关曝光埋点值
export const COUPON_SUPPLY_BID_MV = {
  SUPPLY_LIST: 'b_waimai_3k7xpfot_mv', // 供给整体曝光
  POI: 'b_waimai_oz8py0nu_mv', // 店铺曝光
  COUPON: 'b_waimai_6ogeg7ac_mv', // 下挂券曝光
}

// 下挂券相关点击埋点值
export const COUPON_SUPPLY_BID_MC = {
  SUPPLY_LIST: 'b_waimai_3k7xpfot_mc', // 供给整体点击
  POI: 'b_waimai_oz8py0nu_mc', // 店铺点击
  COUPON: 'b_waimai_6ogeg7ac_mc', // 下挂券点击
}
